import { action } from "easy-peasy";

export const LanguageChangeState = {
  defaultLanguage: "en-us",
  changeCurrentLanguage: action((state, payload) => {
    state.defaultLanguage = payload;
  }),
};
